import { render, staticRenderFns } from "./templateItemList.vue?vue&type=template&id=097241f6&scoped=true&"
import script from "./templateItemList.vue?vue&type=script&lang=js&"
export * from "./templateItemList.vue?vue&type=script&lang=js&"
import style0 from "./templateItemList.vue?vue&type=style&index=0&id=097241f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097241f6",
  null
  
)

export default component.exports